import { createStore } from '../../lib/create-store';

import { getActions, getInitialState, getReducer } from '.';

const ACTION_PREFIX = 'AUTO_PUSH_NOTIFICATIONS';

const initialState = getInitialState();
const reducer = getReducer(ACTION_PREFIX);

export const autoPushNotificationsStore = createStore({
  initialState,
  reducer,
  name: 'autoPushNotificationsStore',
});

export const autoPushNotificationsActions = getActions(ACTION_PREFIX);
